import { TextArea } from '@radix-ui/themes';
import { Path } from 'react-hook-form';
import { CollectionMetadata } from '../types';
import { MetadataFieldWrapper } from './MetadataFieldWrapper';
import { useMetadataField } from '../hooks/useMetadataField';

export interface TextAreaMetadataFieldProps {
    name: Path<CollectionMetadata>;
    placeholder?: string;
}

export const TextAreaMetadataField = ({
    name,
    placeholder,
}: TextAreaMetadataFieldProps) => {
    const hookData = useMetadataField<string>({ name });
    const { field } = hookData;

    return (
        <MetadataFieldWrapper {...hookData}>
            <TextArea
                size='2'
                name={field.name}
                value={field.value}
                placeholder={placeholder}
                onBlur={field.onBlur}
                onChange={field.onChange}
                style={{
                    minHeight: '132px',
                    maxHeight: '270px',
                    resize: 'vertical',
                }}
            />
        </MetadataFieldWrapper>
    );
};
